
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-5.5 -5.5)","fill":"#172a55"}},[_c('path',{attrs:{"data-name":"Path 66","d":"M45.148 5.5h-33.3A6.352 6.352 0 005.5 11.852V34.2a6.352 6.352 0 006.352 6.352H28.5l12.464 10.69a1.139 1.139 0 00.723.263 1.183 1.183 0 00.46-.11 1.051 1.051 0 00.591-.986v-9.861h2.41A6.352 6.352 0 0051.5 34.2V11.852A6.352 6.352 0 0045.148 5.5zm4.162 28.7a4.162 4.162 0 01-4.162 4.162h-3.5a1.1 1.1 0 00-1.1 1.1v8.565L29.6 38.62a1.139 1.139 0 00-.723-.263H11.852A4.162 4.162 0 017.69 34.2V11.852a4.162 4.162 0 014.162-4.162h33.3a4.162 4.162 0 014.162 4.162z"}}),_c('path',{attrs:{"data-name":"Path 67","d":"M29.551 12.159a5.87 5.87 0 00-6.9 5.761 1.117 1.117 0 001.1 1.1 1.1 1.1 0 001.1-1.1 3.658 3.658 0 017.25-.679 3.7 3.7 0 01-1.4 3.636 7.36 7.36 0 00-3.242 5.936V28.5a1.1 1.1 0 002.19 0v-1.686a5.235 5.235 0 012.322-4.162 5.849 5.849 0 00-2.376-10.493z"}}),_c('circle',{attrs:{"data-name":"Ellipse 13","cx":"1.095","cy":"1.095","r":"1.095","transform":"translate(27.405 30.69)"}})])])
          )
        }
      }
    